export default __webpack_public_path__ + "static/media/successGreen.9d5062cb.svg";